import { Role } from "@/entities";
import { LazyAsyncIter } from "@/iterators";
import { AsyncPaginatedRequest } from "@/services";
import Paginated, { pageMapperBuilder } from "@/pagination/paginated";
import HttpService from "./http-service";
/**
 * Data transfer object of a Role.
 */
interface RoleDTO {
  id: number;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
}

/**
 * Converts the RoleDTO to a Role entity.
 */
export function roleFromDTO(dto: RoleDTO): Role {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    createdAt: new Date(Date.parse(dto.created_at)),
    updatedAt: new Date(Date.parse(dto.updated_at)),
  };
}

/**
 * Queries data of roles from the API.
 */
export default class RoleService extends HttpService {
  /**
   * Gets the Role of roleId.
   *
   * @param roleId - The id of the role to query.
   * @returns The Role entity of roleId.
   */
  async getRole(roleId: number): Promise<Role | null> {
    const response = await this.httpClient.get<RoleDTO>(`roles/${roleId}`);
    return roleFromDTO(response.data);
  }

  /**
   * Gets the all the Roles.
   *
   * @returns All the roles.
   */
  getRoles(): AsyncIterator<Paginated<Role>> {
    const requestIter = new AsyncPaginatedRequest<RoleDTO>(
      "get",
      "roles",
      undefined,
      undefined,
      this.httpClient
    )[Symbol.asyncIterator]();
    return new LazyAsyncIter(requestIter).map(pageMapperBuilder(roleFromDTO));
  }
}
